/* global $ */
/* global yaCounter44690404 */

var Proj = (function(proj){
    'use strict';

    proj.Targets = function() {

        function processGoal(goal) {
            try {
                yaCounter44690404.reachGoal(goal);
                console.info('processGoal', goal);
            } catch (err) {
                console.error('processGoal', goal, err);
            }
        }

        $(document.body).on('click', '.js-goal-link', function(e) {
            var goal = $(this).data('goal');
            if (goal) {
                processGoal(goal);
                ga('send', 'event', 'click', goal);
            }
            return true;
        });

        $(document.body).on('submit', '.js-goal-form', function(e) {
            var goal = $(this).data('goal');
            if (goal) {
                processGoal(goal);
                ga('send', 'event', 'submit', goal);
            }
            return true;
        });
    };

    return proj;
})(Proj || {});



